define(function(require) {
  return Backbone.Model.extend({
  	url: '/autologin',
    url000: '/delegate/web?p_p_id=58&p_p_lifecycle=1&p_p_state=normal&p_p_mode=view&p_p_col_id=column-1&p_p_col_count=1&_58_struts_action=%2Fportal%2Flogin2',
  });
});
